import React from 'react';

export const UnArchiveInformationBlock = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="24" height="24" rx="4" fill="#EAEBED" />
            <g clipPath="url(#clip0_2359_2628)">
                <path
                    d="M19.0168 8.44626L7.74047 4.34202C7.49125 4.25131 7.2162 4.26332 6.97584 4.3754C6.73547 4.48749 6.54947 4.69047 6.45876 4.93969L5.94573 6.34923C5.85502 6.59845 5.86703 6.8735 5.97912 7.11387C6.0912 7.35424 6.5434 7.63094 6.5434 7.63094L16.88 11.3932L17.8197 11.7352C17.8197 11.7352 18.344 11.8139 18.5844 11.7018C18.8247 11.5897 19.0107 11.3867 19.1014 11.1375L19.6145 9.72797C19.7052 9.47875 19.6932 9.2037 19.5811 8.96334C19.469 8.72297 19.266 8.53697 19.0168 8.44626ZM18.1617 10.7955L6.88542 6.69125L7.39845 5.28171L18.6748 9.38595L18.1617 10.7955Z"
                    fill="#757575"
                />
                <path
                    d="M18 11C17.7348 11 6.00004 11 6.00004 11C6.00004 11 6.00002 11.6095 6.00002 12C5.99997 14.1479 6.00003 17.5 6.00003 17.5C6.00003 17.7652 6.10539 18.0196 6.29292 18.2071C6.48046 18.3946 6.73481 18.5 7.00003 18.5H17C17.2652 18.5 17.5196 18.3946 17.7071 18.2071C17.8947 18.0196 18 17.7652 18 17.5V12L18 11ZM17 17.5H7.00003V12H17V17.5ZM10 14C10 13.8674 10.0527 13.7402 10.1465 13.6464C10.2402 13.5527 10.3674 13.5 10.5 13.5H13.5C13.6326 13.5 13.7598 13.5527 13.8536 13.6464C13.9474 13.7402 14 13.8674 14 14C14 14.1326 13.9474 14.2598 13.8536 14.3536C13.7598 14.4473 13.6326 14.5 13.5 14.5H10.5C10.3674 14.5 10.2402 14.4473 10.1465 14.3536C10.0527 14.2598 10 14.1326 10 14Z"
                    fill="#757575"
                />
            </g>
            <defs>
                <clipPath id="clip0_2359_2628">
                    <rect width="16" height="16" fill="white" transform="translate(4 4)" />
                </clipPath>
            </defs>
        </svg>
    );
};
